<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="" effect="light" expand>
            <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                <img src="img/logo.png" alt="magicom">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
                        <img src="img/logo_blue.png" alt="magicom">
                    </router-link>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
               
                <a slot="title" href="/" class="nav-link">
                    <span class="nav-link-inner--text">Home</span>
                </a>

                <base-dropdown tag="li" class="nav-item">
                    <a slot="title" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-collection d-lg-none"></i>
                        <span class="nav-link-inner--text">Solutions</span>
                    </a>
                    <router-link to="/solutions/autonomous-driving" class="dropdown-item">Autonomous Driving</router-link>
                    <router-link to="/solutions/smart-home" class="dropdown-item">Smart Home</router-link>
                    <router-link to="/solutions/manufacturing" class="dropdown-item">Manufacturing</router-link>
                    <router-link to="/solutions/smart-retail" class="dropdown-item">Smart Retail</router-link>
                    <router-link to="/solutions/mobile-apps" class="dropdown-item">Mobile Apps</router-link>
                    <router-link to="/solutions/robotics" class="dropdown-item">Robotics</router-link>
                </base-dropdown>

                <base-dropdown tag="li" class="nav-item">
                    <a slot="title" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-ui-04 d-lg-none"></i>
                        <span class="nav-link-inner--text">Services</span>
                    </a>
                    <router-link to="/services/data/collection" class="dropdown-item">Data Collection</router-link>
                    <router-link to="/services/data/cleaning" class="dropdown-item">Data Cleaning</router-link>
                    <router-link to="/services/data/annotation" class="dropdown-item">Data Annotation</router-link>
                    <router-link to="/services/data/augmentation" class="dropdown-item">Data Augmentation</router-link>
                </base-dropdown>

                <base-dropdown tag="li" class="nav-item">
                    <a slot="title" class="nav-link" data-toggle="dropdown" role="button">
                        <i class="ni ni-building d-lg-none"></i>
                        <span class="nav-link-inner--text">Company</span>
                    </a>
                    <router-link to="/about" class="dropdown-item">About</router-link>
                    <router-link to="/careers" class="dropdown-item">Careers</router-link>
                    <router-link to="/contact" class="dropdown-item">Contact us</router-link>
                </base-dropdown>
            </ul>
            <ul class="navbar-nav align-items-lg-center ml-lg-auto">
            <router-link to="/login" class="btn btn-neutral btn-icon">
                <i class="fa fa-user mr-2"></i>
                <span class="nav-link-inner--text">Login</span>
             </router-link>
            </ul>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
};
</script>
<style>
</style>
